// PDF describing the laws by locale
// https://confluence.expedia.biz/display/PRIV/Privacy+Standards+and+Guidance?preview=/910749800/1395428049/Privacy%20Guidance_B2C%20Marketing_March%202020%20approved%20SKK%2003-10-2020%20editedTL.pdf
const optStatus = {
    OPT_IN_CHECKBOX: 'OPT_IN_CHECKBOX',
    OPT_IN_CHECKBOX_UNCHECKED: 'OPT_IN_CHECKBOX_UNCHECKED',
    OPT_OUT_CHECKBOX: 'OPT_OUT_CHECKBOX',
    OPT_IN_DEFAULT: 'OPT_IN_DEFAULT'
};

const haSites = {
    HA_AU: 'homeaway_au',
    HA_NZ: 'homeaway_nz',
    HA_LK: 'homeaway_lk',
    HA_SG: 'homeaway_sg',
    HA_JP: 'homeaway_jp',
    HA_AT: 'homeaway_at',
    HA_DE: 'homeaway_de',
    VRBO: 'vrbo',
    VR: 'vr',
    ABRITEL: 'abritel',
    HA_US: 'homeaway_us'
};

const getMarketingEmailOptStatus = (siteName) => {
    if (siteName) {
        switch (siteName) {
        case haSites.HA_NZ:
        case haSites.HA_LK:
        case haSites.HA_AU:
        case haSites.HA_JP:
            return optStatus.OPT_IN_CHECKBOX;
        case haSites.HA_US:
        case haSites.VRBO:
        case haSites.VR:
            return optStatus.OPT_IN_DEFAULT;
        default:
            return optStatus.OPT_OUT_CHECKBOX;
        }
    }
    return optStatus.OPT_OUT_CHECKBOX;
};

const getOptOutState = (siteName, emailOptOut, explicitlyChosen) => {
    // If the user has explicitly set their options use, whatever they set.
    // If they have not set the options, then return the initial optOut state
    // for their region based on sitename.
    if (explicitlyChosen) {
        return emailOptOut;
    }

    switch (siteName) {
    case haSites.HA_AU:
    case haSites.HA_JP:
        return true;
    default:
        return false;
    }
};

const hasOptOutAnyTime = (siteName) => {
    if (siteName) {
        switch (siteName) {
        case haSites.HA_AT:
        case haSites.HA_DE:
        case haSites.ABRITEL:
            return true;
        default:
            return false;
        }
    }
    return false;
};
export {
    optStatus,
    getMarketingEmailOptStatus,
    getOptOutState,
    hasOptOutAnyTime
};
